import React, { useEffect, useState, useCallback } from "react";
import styled from "styled-components";
import { Tooltip } from "antd";

import LeftSidePanel from "../leftPanelContent/LeftSidePanel";
import AmeaButtons from "./AmeaButtons";
import RightSidePanel from "../rightPanelContent/RightSidePanel";
import MapAMEA from "../smartiscity/MapAMEA";
import ViewModal from "./ViewModal";
import * as Icon from "../smartiscity/Icons";
import "./MapContainer.css";
import { useAuth } from "../../../hooks/UserAuthProvider";
import { handleLogin } from "../utils";
import { Link } from "react-router-dom";

const MapContainer = ({
  data,
  loading = false,
  categoryId,
  selectedCategory,
  showNewRouteForm,
  refresh,
}) => {
  const [showRightSide, setShowRightSide] = useState(false);
  const [showLeftSide, setShowLeftSide] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);
  const [selectedRoute, setSelectedRoute] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [randomNumber, setRandomNumber] = useState(3213);
  const [showInfrastructuresOnNewRoute, setShowInfrastructuresOnNewRoute] =
    useState(true);

  const onCloseModal = useCallback(() => setShowModal(false), []);
  const handleLeftSide = useCallback((value) => setShowLeftSide(value), []);
  const resetSelectedItem = useCallback(() => {
    setSelectedItem(null);

    setShowRightSide(false);
  }, [selectedCategory.get]);

  const getRandomNumber = useCallback(() => {
    setRandomNumber(Math.floor(Math.random() * 1000));
  }, []);
  const { isAuthenticated } = useAuth();

  useEffect(() => {
    // setShowRightSide(false);
    // setSelectedItem(null);
    resetSelectedItem();
  }, [categoryId, selectedCategory.get]);

  useEffect(() => {
    showNewRouteForm.set((prevState) => prevState);
  }, [selectedCategory.get, showNewRouteForm]);

  useEffect(() => {
    getRandomNumber();
  }, [
    categoryId,
    selectedCategory.get,
    showNewRouteForm.get,
    refresh,
    data,
    getRandomNumber,
  ]);

  const handleSelectedRoute = (route) => {
    setSelectedRoute(route);
  };

  // useEffect(() => {
  //   if (selectedCategory.get === "routes" && data.length > 0) {
  //     setSelectedRoute(data[0]);
  //   }
  // }, [data, selectedCategory.get]);

  const mapKey =
    categoryId === "122"
      ? `${selectedCategory.get}_${randomNumber}`
      : `other_${categoryId ?? "other"}_${randomNumber}`;

  return (
    <Container>
      <LeftSidePanel
        data={data}
        loading={loading}
        selectedItem={{ getItem: selectedItem, setItem: setSelectedItem }}
        rightSideBox={{
          isVisible: showRightSide,
          setIsVisible: setShowRightSide,
        }}
        categoryId={categoryId}
        selectedCategory={selectedCategory.get}
        handleLeftSide={handleLeftSide}
        setSelectedRoute={handleSelectedRoute}
        showNewRouteForm={showNewRouteForm}
        refreshComponent={refresh}
        refreshMap={getRandomNumber}
      />
      {categoryId === "122" && !showNewRouteForm.get && (
        <AmeaButtons
          selectedCategory={selectedCategory}
          visibleRightSide={showRightSide}
          visibleLeftSide={showLeftSide}
          resetSelectedItem={resetSelectedItem}
        />
      )}

      {categoryId === "122" &&
        selectedCategory.get === "routes" &&
        !showNewRouteForm.get && (
          <Tooltip title="Νέα Διαδρομή" placement="left">
            <NewRoute
              $showNewRoute={showNewRouteForm.get}
              onClick={() => {
                if (isAuthenticated) {
                  showNewRouteForm.set(true);
                } else {
                  setShowModal(true);
                }
              }}
            >
              <img src={Icon.addCircle} alt="Add new route" />
            </NewRoute>
          </Tooltip>
        )}

      {categoryId === "122" &&
        selectedCategory.get === "routes" &&
        showNewRouteForm.get && (
          <Tooltip
            title={`${
              showInfrastructuresOnNewRoute ? "Απόκρυψη" : "Εμφάνηση"
            } Υποδομών`}
            placement="left"
          >
            <ToggleInfrastructures
              $isInfrastructuresVisible={showInfrastructuresOnNewRoute}
              onClick={() => {
                setShowInfrastructuresOnNewRoute(
                  !showInfrastructuresOnNewRoute
                );
              }}
            >
              <ToggleDot
                $isInfrastructuresVisible={showInfrastructuresOnNewRoute}
              ></ToggleDot>
            </ToggleInfrastructures>
          </Tooltip>
        )}

      <MapAMEA
        key={mapKey}
        selectedItem={{ getItem: selectedItem, setItem: setSelectedItem }}
        selectedRoute={selectedRoute}
        rightSideBox={{
          isVisible: showRightSide,
          setIsVisible: setShowRightSide,
        }}
        data={data}
        showNewRoute={showNewRouteForm.get}
        selectedCategory={selectedCategory.get}
        categoryId={categoryId}
        showInfrastructuresOnNewRoute={showInfrastructuresOnNewRoute}
      />
      <RightSidePanel
        showRightSide={{ get: showRightSide, set: setShowRightSide }}
        selectedItem={selectedItem}
        categoryId={categoryId}
        selectedCategory={selectedCategory.get}
      />
      {categoryId === "122" && (
        <ViewModal
          modalStatus={showModal}
          title={null}
          closeModal={onCloseModal}
        >
          <ModalContainer>
            <ModalText>
              <p>
                Για να δημιουργήσετε την δικής σας διαδρομή, παρακαλούμε
                συνδεθείτε στον λαγαριασμό σας
              </p>
            </ModalText>
            <NewRouteButton type="primary" onClick={handleLogin}>
              Σύνδεση
            </NewRouteButton>
            <p>
              ή <Link to="/register">δημιουργήσετε έναν καινούργιο.</Link>
            </p>
          </ModalContainer>
        </ViewModal>
      )}
    </Container>
  );
};

export default MapContainer;

const Container = styled.div`
  padding-top: 70px;
  position: relative;
`;

const ModalContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 30px;
  padding-block: 30px;
  justify-content: center;
  align-items: center;
`;

const ModalText = styled.p`
  text-align: center;
  width: 400px;
  margin: 0 auto;
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
  letter-spacing: 0.5%;
`;

const NewRoute = styled.div`
  position: absolute;
  top: ${(props) => (props.$showNewRoute ? "110px" : "130px")};
  right: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 2;
  box-shadow: 0 0 8px 2px rgba(0, 0, 0, 0.1);
  width: 40px;
  height: 40px;
  background: #27aae1;
  border-radius: 4px;
  &:hover {
    background-color: #4bc7fa;
  }
  transition: all 0.5s ease;
`;

const ToggleInfrastructures = styled.div`
  position: absolute;
  top: 86px;
  right: 56px;
  background-color: ${(props) =>
    props.$isInfrastructuresVisible ? "green" : "gray"};
  border-radius: 30px;
  width: 50px;
  height: 30px;
  z-index: 3;
  cursor: pointer;
  transition: all 0.5s ease;
`;

const ToggleDot = styled.div`
  position: absolute;
  top: 3px;
  left: ${(props) => (props.$isInfrastructuresVisible ? "21px" : "1px")};
  margin-inline: 2px;
  width: 24px;
  height: 24px;
  background-color: #fff;
  border-radius: 50%;
  transition: all 0.5s ease;
`;

const NewRouteButton = styled.button`
  border-radius: 12px;
  background-color: #27aae1;
  width: fit-content;
  height: fit-content;
  padding: 10px 40px;
  color: #000;
  font-weight: 500;
  font-size: 16px;
  line-height: 20px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: 8px;
  &:hover {
    background-color: #4bc7fa;
  }
  transition: all 0.6s ease;
`;
